import { Component } from '@theme/component';

/**
 * Adds inline validation messages to the Arabian Aura contact form.
 * Wraps Shopify's built-in `{% form 'contact' %}` so the form still
 * submits and is processed by Shopify when all fields are valid.
 *
 * @extends Component
 */
class AAContactForm extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.form = this.querySelector('form');
    if (!this.form) return;

    this.form.addEventListener('submit', this.handleSubmit);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.form?.removeEventListener('submit', this.handleSubmit);
  }

  /**
   * Validates required and pattern-matched fields, showing an inline
   * error message next to each invalid field and blocking submission
   * until all fields pass.
   *
   * @param {SubmitEvent} event
   */
  handleSubmit = (event) => {
    if (!this.form) return;

    let firstInvalidField = null;

    for (const field of this.form.querySelectorAll('[data-validate]')) {
      if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement)) continue;

      const errorElement = this.querySelector(`[data-error-for="${field.name}"]`);
      let message = '';

      if (field.validity.valueMissing) {
        message = field.dataset.errorRequired || 'This field is required.';
      } else if (field.validity.typeMismatch || field.validity.patternMismatch) {
        message = field.dataset.errorType || 'Please enter a valid value.';
      }

      field.classList.toggle('aa-contact__field-input--invalid', Boolean(message));
      field.setAttribute('aria-invalid', message ? 'true' : 'false');
      if (errorElement) errorElement.textContent = message;

      if (message && !firstInvalidField) firstInvalidField = field;
    }

    if (firstInvalidField) {
      event.preventDefault();
      firstInvalidField.focus();
    }
  };
}

if (!customElements.get('aa-contact-form')) {
  customElements.define('aa-contact-form', AAContactForm);
}
